import getToken from "../lib/get-token";
import CompanySearch from "../components/CompanySearch";

export default function Home({ searchEndpoint }) {
	return (
		<div className="container">
			<CompanySearch searchEndpoint={searchEndpoint} />
		</div>
	);
}

export async function getStaticProps({ context }) {
	const token = await getToken();
	const searchEndpoint = process.env.SEARCH_ENDPOINT || "opten";
	return {
		props: {
			searchEndpoint,
		},
	};
}
